import { Config } from '@adornis/config/config.js';

export const LDAP_IMPLEMENTATIONS = ['tu-darmstadt', 'goetheuni-frankfurt', 'adornis-authentik'] as const;
export const SAML_IMPLEMENTATIONS = ['tu-darmstadt', 'adornis-authentik', 'hs-fulda', 'dfn-aai'] as const;

export const config = new Config('buchungsheld', {
  // if empty will not render ldap login functionality
  LDAP_IMPLEMENTATION: {
    env: true,
    name: 'LDAP_IMPLEMENTATION',
    client: true,
    required: false,
    defaultVal: '',
    parse(value) {
      if (value && !LDAP_IMPLEMENTATIONS.includes(value as any))
        throw new Error(
          `LDAP_IMPLEMENTATION has to be one of the following: ${LDAP_IMPLEMENTATIONS.join(', ')}. Got ${value}`,
        );
      return value as (typeof LDAP_IMPLEMENTATIONS)[number] | '';
    },
  },
  // if empty will not render saml login functionality
  SAML_IMPLEMENTATION: {
    env: true,
    name: 'SAML_IMPLEMENTATION',
    client: true,
    required: false,
    defaultVal: '',
    parse(value) {
      if (value && !SAML_IMPLEMENTATIONS.includes(value as any))
        throw new Error(
          `SAML_IMPLEMENTATION has to be one of the following: ${SAML_IMPLEMENTATIONS.join(', ')}. Got ${value}`,
        );
      return value as (typeof SAML_IMPLEMENTATIONS)[number] | '';
    },
  },
  // if true will use popup for saml login
  SAML_USE_POPUP: {
    env: true,
    name: 'SAML_USE_POPUP',
    client: true,
    required: false,
    defaultVal: '',
  },
  //reads the preselected IdP
  SAML_PRESELECTED_IDP: {
    env: true,
    name: 'SAML_PRESELECTED_IDP',
    client: true,
    required: false,
    defaultVal: '',
  },
});
